import angular from 'angular';
import { TurnosTrabajosComponent, translationKeys } from './turnos-trabajos.component';
import './turnos-trabajos.scss';
import spaI18N from 'core/i18n';
import BasicFactory from 'core/services/basicfactory';


export * from './turnos-trabajos.component';

export default angular.module('turnos-trabajos.list', [
  'ui',
  spaI18N
])
  .config(config)
  .factory('BasicFactory', BasicFactory)
  .component(TurnosTrabajosComponent.selector, TurnosTrabajosComponent)
  .name;

config.$inject = ['$stateProvider'];

function config($stateProvider) {
  $stateProvider
    .state('home.turnos-trabajos.list', {
      url: '',
      template: '<turnos-trabajos translations="$resolve.translations"></turnos-trabajos>',
      resolve: {
        translations
      },
      access: {
        requiresLogin: true
      },
      ncyBreadcrumb: {
        parent: 'home',
        label: 'Listado de turnos de trabajo'
      }
    });
}

translations.$inject = ['LangService'];

function translations(LangService) {
  return LangService.getTranslations(translationKeys);
}


// WEBPACK FOOTER //
// ./src/components/turnos-trabajos/list/index.js